import { useEffect } from 'react'
import { useStorage, useMutation, useOthers, useSelf } from '@liveblocks/react'
import { useSelector } from 'react-redux'
import { RootState } from '@redux/store'

// TODO: Check the behavior of Lock Mode in case the Owner loses connection (useOthersListener)

export const useReviewLock = () => {
  const currentUser = useSelector((state: RootState) => state.Auth.user)
  const userId = currentUser?.uuid.toString() ?? null

  const lock = useStorage(root => root.lock)
  const others = useOthers()
  const self = useSelf()
  const isLocked = lock && lock.lockedBy !== self?.id
  const isOwner = lock && lock.lockedBy === self?.id

  const setLock = useMutation(({ storage }) => {
    storage.set('lock', { lockedBy: userId, lockedAt: Date.now(), isLocked: true })
  }, [])

  const releaseLock = useMutation(({ storage }) => {
    storage.delete('lock')
  }, [])

  useEffect(() => {
    if (!lock?.lockedBy) return

    const lockOwnerStillHere =
      lock.lockedBy === self?.id || others.some(user => user.id === lock.lockedBy)

    if (!lockOwnerStillHere) {
      releaseLock()
    }

    return () => {
      if (!isOwner) {
        releaseLock()
      }
    }
  }, [others, self, releaseLock, isOwner])

  return {
    lock,
    setLock,
    releaseLock,
    isLocked,
    isOwner,
  }
}
